<script>
import { cloneDeep, filter } from 'lodash-es';
import { mapActions, mapState } from 'vuex';
import TwTimeStamp from '../TwTimeStamp';
import TwSearchableSelect from '../TwSearchableSelect';
import TwentyService from '../../services/twenty-service';
import Vue from 'vue';

export default {
  name: 'ItineraryDayProgramGolfModal',
  components: {
    TwTimeStamp,
    TwSearchableSelect,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dayProgramItems: {
      type: Array,
      default: () => [],
    },
    availableExtras: {
      type: Array,
      default: () => [],
    },
    countriesAndAreas: {
      type: Array,
      default: () => [],
    },
    itineraryId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      twentyUrl: `${process.env.TWENTY_FRONT_PAGE}/support-system/extra`,
      toggled: true,
      search: '',
      selectedAreaId: null,
      // "Golf course"
      selectedCategoryId: 3,
      showOnlySelectedExtras: false,
      defaultHeaders: [
        { text: '#', align: 'left', value: 'id' },
        { text: this.$t('itinerary.extraModal.table.name'), align: 'left', value: 'description' },
        { text: this.$t('itinerary.extraModal.table.supplier'), align: 'left', value: 'supplier.name' },
        { text: this.$t('itinerary.extraModal.table.inclusive'), align: 'center', sortable: false },
        { text: this.$t('itinerary.extraModal.table.optional'), align: 'center', sortable: false },
      ],
      headers: [
        { text: 'Day', className: 'day', classOverride: 'text-align: center;' },
        { text: 'Opt.', className: 'opt', classOverride: 'text-align: center;' },
        { text: 'Name', className: 'name' },
        { text: 'Holes', className: 'holes' },
        { text: 'Tee time', className: 'tee-time' },
        { text: 'Tee', className: 'tee' },
        { text: 'No. GF', className: 'green-fees' },
        { text: 'Addons', className: 'addons' },
        { text: 'Net Price.', className: 'net-price' },
        { text: 'Supp ref.', className: 'supplier-ref' },
        { text: 'Supp.', className: 'supplier', classOverride: 'text-align: center;' },
        { text: '', className: 'actions' },
      ],
      pagination: {
        rowsPerPage: 25,
        descending: false,
        sortBy: 'name',
      },
      extras: [],
      extraAdditionals: [],
      creatingCustomExtra: null,
      anyNew: null,
    };
  },
  computed: {
    ...mapState({
      config: state => state.itinerary.dayProgramExtras.config,
      itinerarySuppliers: state => state.itinerary.itinerarySuppliers.items,
    }),
    ...mapActions({
      getItinerarySuppliers: 'itinerary/getItinerarySuppliers',
    }),
    categoryConfig() {
      if (!this.selectedCategoryId || !this.config || !this.config[this.selectedCategoryId]) {
        return new Map();
      }

      const categoryConfig = new Map();

      Object.entries(this.config[this.selectedCategoryId]).forEach(([ key, value ]) => {
        let options;

        if (value.options) {
          options = Object.entries(value.options).map(([ valueKey, label ]) => ({
            value: +valueKey,
            label,
          }));
        } else {
          options = Object.entries(value).map(([ valueKey, label ]) => ({
            value: +valueKey,
            label,
          }));
        }

        categoryConfig.set(key, {
          ...value,
          options,
        });
      });

      return categoryConfig;
    },
    filteredCategoryExtras() {
      let filteredExtras = this.extras;

      if (this.selectedCategoryId) {
        filteredExtras = filteredExtras.filter(extra => extra.extraCategoryId === this.selectedCategoryId);
      }

      if (this.showOnlySelectedExtras) {
        filteredExtras = filteredExtras.filter(extra => extra.type === 'included' || extra.type === 'optional');
      }

      return filteredExtras;
    },
    sortedExtraAdditionals() {
      const localExtraAdditionals = this.extraAdditionals;
      const uniqueDayProgramDays = {};
      this.dayProgramItems.forEach(dayProgram => {
        if (!uniqueDayProgramDays[dayProgram.day]) {
          uniqueDayProgramDays[dayProgram.day] = [];
        }
      });
      localExtraAdditionals/*.filter(additional => !additional.shouldBeDeleted)*/.forEach((additional, index) => {
        if (!uniqueDayProgramDays[additional.day]) {
          uniqueDayProgramDays[additional.day] = [];
        }
        additional.index = index;
        uniqueDayProgramDays[additional.day].push(additional);
      });
      return uniqueDayProgramDays;
    },
  },
  watch: {
    toggled(value) {
      if (!value) {
        this.$emit('cancel');
      }
    },
    availableExtras(value) {
      this.extras = cloneDeep(value);
    },
  },
  created() {
    this.getItinerarySuppliers(this.itineraryId);
  },
  mounted() {
    this.extraAdditionals = this.dayProgramItems.flatMap(item => {
      if (item.extras && item.extras.length > 0 && item.extras.some(extra => extra.extraCategoryId === 3)) {
        return item.extras.filter(extra => extra.extraCategoryId === 3).map(extra => ({
          ...extra,
          dayProgramId: item.id,
          day: item.day,
          extraId: extra.id,
          holes: extra.holes ? extra.holes : 18,
          numberOfGreenfees: null,
          netPrice: extra.netPrice ? extra.netPrice : 0,
          shouldBeDeleted: false,
          supplierRef: extra.supplierRef ? extra.supplierRef : null,
          tee: extra.tee ? extra.tee : 1,
        }));
      }
      return [ this.createInitialAdditional(item.alias, item.id, item.day) ];
    });
  },
  methods: {
    createInitialAdditional(alias, dayProgramId, dayProgramDay) {
      return {
        id: null,
        alias,
        dayProgramId,
        day: dayProgramDay,
        extraId: null,
        extraCategoryId: 3,
        teeTime: null,
        holes: null,
        tee: null,
        numberOfGreenfees: null,
        netPrice: null,
        addon: null,
        option: null,
        supplier: { id: null, currency: '' },
        supplierId: null,
        type: 'included',
        extraCategories: null,
        supplierRef: null,
        shouldBeDeleted: false,
        itineraryDayProgramExtraId: null,
        index: null,
      };
    },
    update() {
      this.$emit('update', {
        itineraryId: this.itineraryId,
        extras: this.extraAdditionals,
      });
    },
    getCategoryConfigByKey(category, key) {
      const categoryConfigItem = this.categoryConfig.get(category);
      if (!categoryConfigItem) {
        return null;
      }

      switch (key) {
        case 'options':
          return categoryConfigItem.options ? categoryConfigItem.options : [];
        case 'multiSelect':
          return !!categoryConfigItem.multiSelect;
        default:
          return categoryConfigItem;
      }
    },
    duplicateExtra(extraIndex) {
      const extra = this.extraAdditionals[extraIndex];
      const newExtra = cloneDeep(extra);
      newExtra.itineraryDayProgramExtraId = null;
      newExtra.index = extraIndex + 1;
      this.anyNew = extraIndex + 1;
      this.extraAdditionals.splice(extraIndex + 1, 0, newExtra);
      this.extraAdditionals.forEach(additional => {
        if (additional.index >= extraIndex + 1) {
          additional.index += 1;
        }
      });
    },
    removeExtra(index) {
      if (this.loading) {
        return;
      }
      const allSimilarExtrasOnThisDay = this.extraAdditionals.filter(
        extra => extra.dayProgramId === this.extraAdditionals[index].dayProgramId && extra.extraId === this.extraAdditionals[index].extraId
      );
      if (allSimilarExtrasOnThisDay.length > 1) {
        if (confirm('There are multiple instances of this extra on this day. Deleting one will remove all extras ' +
          'of the same type of this given day due to current system limitations. They will need to be readded manually afterwards. Continue?')
        ) {
          this.extraAdditionals.forEach(extraAdditional => {
            if (extraAdditional.dayProgramId === this.extraAdditionals[index].dayProgramId &&
              extraAdditional.extraId === this.extraAdditionals[index].extraId
            ) {
              if (extraAdditional.itineraryDayProgramExtraId) {
                Vue.set(extraAdditional, 'shouldBeDeleted', true);
              } else {
                this.extraAdditionals.splice(this.extraAdditionals.indexOf(extraAdditional), 1);
              }
            }
          });
        }
        return;
      }
      if (this.extraAdditionals[index].itineraryDayProgramExtraId) {
        Vue.set(this.extraAdditionals[index], 'shouldBeDeleted', true);
      } else {
        this.extraAdditionals.splice(index, 1);
      }
    },
    handleNewExtra(newExtra, itemIndex, dayProgramId) {
      this.creatingCustomExtra = {
        extraCategory: 'Golf Course',
        extraCategoryId: 3,
        alias: newExtra,
        id: null,
        supplierId: null,
        supplier: null,
        itineraryId: this.itineraryId,
        dayProgramId,
        type: 'included',
        rule: 'accommodation',
        sell: 'booking',
        index: itemIndex,
      };
    },
    createNewExtra() {
      TwentyService.createNewCustomExtra(this.creatingCustomExtra).then(response => {
        this.extras.push(response.data);
        const data = response.data;
        const newExtra = {
          ...this.extraAdditionals[this.creatingCustomExtra.index],
          extraId: data.id,
          id: data.id,
          extraCategoryId: data.extraCategoryId,
          alias: data.alias,
          areaId: data.areaId,
          contentId: data.contentId,
          itineraryId: data.itineraryId,
          type: data.type,
          rule: data.rule,
          sell: data.sell,
          supplierId: data.supplierId,
          supplier: {},
          tee: 1,
          holes: 18,
        };
        const newSupplier = this.itinerarySuppliers.find(
          supplier => supplier.id === data.supplierId
        );
        Vue.set(this.extraAdditionals, this.creatingCustomExtra.index, newExtra);
        Vue.set(this.extraAdditionals[this.creatingCustomExtra.index], 'supplier', newSupplier);
        this.creatingCustomExtra = null;
      });
    },
    handleTeeAndHoles(extraId, index) {
      if (this.extraAdditionals[index].extraId && this.extraAdditionals[index].extraId !== extraId) {
        let extraCopy = {
          ...this.extraAdditionals[index],
          shouldBeDeleted: true,
        };
        this.extraAdditionals.push(extraCopy);
      }
      this.extraAdditionals[index].extraId = extraId;
      this.extraAdditionals[index].itineraryDayProgramExtraId = null;
      if (this.extraAdditionals[index].tee === null) {
        this.extraAdditionals[index].tee = 1;
      }
      if (this.extraAdditionals[index].holes === null) {
        this.extraAdditionals[index].holes = 18;
      }
      if (extraId) {
        this.extraAdditionals[index].supplier = this.availableExtras.find(extra => extra.id === extraId).supplier;
        Vue.set(this.extraAdditionals[index], 'supplierId', this.extraAdditionals[index].supplier.id);
      }
      this.extraAdditionals[index].netPrice = 0;
    },
    updateSameSuppliers(event, supplierId) {
      this.extraAdditionals.forEach(extraAdditional => {
        if (extraAdditional.supplier.id === supplierId) {
          extraAdditional.supplierRef = event;
        }
      });
    },
    addExtraOnDayProgramDay(day) {
      const dayProgramId = this.dayProgramItems.find(item => item.day === +day).id;
      const newExtra = this.createInitialAdditional('', dayProgramId, +day);
      this.extraAdditionals.push(newExtra);
    },
  },
};
</script>

<template>
  <v-dialog v-model="toggled">
    <v-card>
      <v-flex font-weight-bold pa-3 title>
        <v-icon>golf_course</v-icon>
        <span>Assign Golf Extras to Day Program</span>
      </v-flex>
      <v-divider light/>
      <v-layout row wrap>
        <v-flex xs12>
          <v-progress-linear
            v-if="loading"
            :active="loading"
            :indeterminate="true"
            :height="4"
            class="my-0"
          />
          <div class="d-flex-row">
            <div
              v-for="header in headers"
              :class="`extra-additionals-table-widths__${header.className}`"
              :style="header.classOverride ? header.classOverride : ''"
              :key="header.text"
            >
              <b>{{ header.text }}</b>
            </div>
          </div>
          <div
            v-for="(extraAdditionalsArray, day) in sortedExtraAdditionals"
            :key="`day-program-day-${day}`"
            :class="{ 'odd-row': day % 2 === 1 }"
            class="mb-3 d-flex-col"
          >
            <div v-if="!extraAdditionalsArray.filter(additional => !additional.shouldBeDeleted).length" class="extra-additionals-table-widths__day">
              <h3 class="align-items-center">{{ day }}</h3>
            </div>
            <div v-if="!extraAdditionalsArray.filter(additional => !additional.shouldBeDeleted).length">
              <v-btn
                :disabled="loading"
                :loading="loading"
                color="blue darken-1"
                flat
                @click="addExtraOnDayProgramDay(day)"
              >
                Add extra on this day
              </v-btn>
            </div>
            <div
              v-for="(extraAdditional, index) in extraAdditionalsArray.filter(additional => !additional.shouldBeDeleted)"
              :key="`extraAdditionals-row-${extraAdditional.index}`"
              :class="anyNew && (anyNew !== extraAdditional.index) ? 'disabled-row' : ''"
              class="d-flex"
            >
              <div class="extra-additionals-table-widths__day align-items-center">
                <h3 v-if="index === 0">{{ day }}</h3>
              </div>
              <div class="extra-additionals-table-widths__opt">
                <v-checkbox
                  :disabled="loading"
                  :input-value="extraAdditional.type === 'optional'"
                  hide-details
                  class="justify-center"
                  @change="extraAdditional.type === 'optional' ? extraAdditional.type = 'included' : extraAdditional.type = 'optional'"
                />
              </div>
              <div class="extra-additionals-table-widths__name">
                <tw-searchable-select
                  :items="filteredCategoryExtras"
                  :disabled="loading"
                  :value="extraAdditional.extraId"
                  item-text="alias"
                  item-value="id"
                  allow-create
                  @input="handleTeeAndHoles($event, extraAdditional.index)"
                  @create="handleNewExtra($event, extraAdditional.index, extraAdditional.dayProgramId)"
                />
              </div>
              <div class="extra-additionals-table-widths__holes">
                <v-select
                  :items="getCategoryConfigByKey('option', 'options')"
                  :multiple="getCategoryConfigByKey('option', 'multiSelect')"
                  :disabled="loading || !extraAdditional.extraId"
                  v-model="extraAdditional.holes"
                  item-text="label"
                  item-value="value"
                />
              </div>
              <div class="extra-additionals-table-widths__tee-time">
                <tw-time-stamp
                  :disabled="loading || !extraAdditional.extraId"
                  v-model="extraAdditional.teeTime"
                  step="600"
                />
              </div>
              <div class="extra-additionals-table-widths__tee">
                <v-select
                  :items="getCategoryConfigByKey('teeOptions', 'options')"
                  :multiple="getCategoryConfigByKey('teeOptions', 'multiSelect')"
                  :disabled="loading || !extraAdditional.extraId"
                  v-model="extraAdditional.tee"
                  item-text="label"
                  item-value="label"
                />
              </div>
              <div class="extra-additionals-table-widths__green-fees">
                <v-text-field
                  v-model.number="extraAdditional.numberOfGreenfees"
                  disabled
                  title="Greenfees cannot be added before a booking has been created"
                  type="number"
                  min="0"
                  step="1"
                />
              </div>
              <div class="extra-additionals-table-widths__addons">
                <v-select
                  :items="getCategoryConfigByKey('addon', 'options')"
                  :multiple="getCategoryConfigByKey('addon', 'multiSelect')"
                  :disabled="loading || !extraAdditional.extraId"
                  v-model="extraAdditional.addon"
                  item-text="label"
                  item-value="value"
                />
              </div>
              <div class="extra-additionals-table-widths__net-price">
                <v-text-field
                  :disabled="loading || extraAdditional.itineraryDayProgramExtraId"
                  v-model.number="extraAdditional.netPrice"
                  type="number"
                  min="0"
                  step="1"
                />
              </div>
              <div class="extra-additionals-table-widths__supplier-ref">
                <v-text-field :value="extraAdditional.supplierRef" @input="updateSameSuppliers($event, extraAdditional.supplier.id)"/>
              </div>
              <div
                v-if="extraAdditional.supplier"
                :title="extraAdditional.supplier.name ? extraAdditional.supplier.name : 'Supplier not found'"
                class="extra-additionals-table-widths__supplier align-items-center"
              >
                {{ extraAdditional.supplier.currency ? extraAdditional.supplier.currency : 'None' }}
              </div>
              <div class="text-xs-right extra-additionals-table-widths__actions">
                <div v-if="anyNew === extraAdditional.index">
                  <v-btn
                    :loading="loading"
                    fab
                    small
                    depressed
                    color="success"
                    @click="anyNew = null"
                  >
                    <v-icon >check</v-icon>
                  </v-btn>
                </div>
                <v-menu v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :loading="loading"
                      v-bind="attrs"
                      fab
                      small
                      depressed
                      color="secondary"
                      v-on="on"
                    >
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile class="action-menu-item" @click="duplicateExtra(extraAdditional.index)">
                      <v-list-tile-action>
                        <v-icon size="20">content_copy</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Duplicate Extra</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile class="action-menu-item" @click="removeExtra(extraAdditional.index)">
                      <v-list-tile-action>
                        <v-icon size="20" color="red">delete</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title class="red--text">Remove Extra</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </div>

        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <v-btn
          color="red darken-1"
          flat
          @click="toggled = false"
        >
          {{ $t('inputs.actions.cancel') }}
        </v-btn>
        <v-btn
          :disabled="loading || anyNew !== null"
          :loading="loading"
          color="blue darken-1"
          flat
          @click="update"
        >
          {{ $t('inputs.actions.save') }}
        </v-btn>
      </v-layout>
    </v-card>
    <v-dialog v-if="creatingCustomExtra" v-model="creatingCustomExtra">
      <v-card>
        <v-card-title class="headline">
          Create New Extra
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="creatingCustomExtra.alias"
            label="Extra Name *"
            required
          />
          <v-spacer class="mt-3"/>
          <tw-searchable-select
            v-model="creatingCustomExtra.supplierId"
            :items="itinerarySuppliers"
            item-text="name"
            item-value="id"
            label="Select Supplier *"
            required
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="!creatingCustomExtra.alias || !creatingCustomExtra.supplierId"
            color="primary"
            @click="createNewExtra"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<style lang="scss">
.odd-row {
  background-color:hsl(0, 0.00%, 98.00%);
}

.odd-row:hover {
  background-color: #eeeeee;
}

.v-menu__content {
  padding: 8px;
  border-radius: 8px;
  background-color: #ffffff;

  .v-list {
    padding: 0;
    gap: 4px;
    display: flex;
    flex-direction: column;

    .action-menu-item {
      gap: 8px;

      .v-list__tile {
        border-radius: 8px;
        overflow: hidden;
        padding: 6px 8px !important;
        height: unset !important;
        display: flex;
        align-items: center;
        flex-direction: row;
        gap: 4px;

        .v-list__tile__action {
          min-width: unset;
        }
      }
    }
  }
}
.create-modal {
  width: 50vw !important;
}

.d-flex-row {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.d-flex-col {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.align-items-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

$extra-additional-column-widths: (
  'day': 2%,
  'opt': 3%,
  'name': 20%,
  'holes': 10%,
  'tee-time': 10%,
  'tee': 8%,
  'green-fees': 8%,
  'addons': 11%,
  'net-price': 8%,
  'supplier-ref': 12%,
  'supplier': 4%,
  'actions': 4%,
);
.extra-additionals-table-widths {
  @each $column, $width in $extra-additional-column-widths {
    &__#{$column} {
      width: $width;
      margin-left: 3px;
      margin-right: 3px;
      input[type='checkbox'] {
        width: 18px;
        height: 18px;
        margin: 0 auto;
        accent-color: #1ab394;
        cursor: pointer;
      }
    }
  }
}
.disabled-row {
  opacity: 0.5;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryDayProgramGolfModal.vue